import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgId48Rounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  "aria-label": "Indonesia",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#e7e7e7",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d43630",
  d: "M12 2A10 10 0 0 0 2 12h20A10 10 0 0 0 12 2"
}));

export { SvgId48Rounded as default };
//# sourceMappingURL=Id48Rounded.js.map
